import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const MicrosoftDynamicsIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor} viewBox="0 0 33 33">
    <path fill="#fff" d="M.07.07h32v32h-32z" />
    <path
      fill="#FFEBEB"
      d="m32.14.14-2.296 2.297a.996.996 0 0 1 .226.633v12.9h2v.2h-2v12.9c0 .24-.085.46-.226.633L32.14 32l-.141.14-2.297-2.296a.995.995 0 0 1-.53.221l-.103.005h-12.9v2h-.2v-2H3.07l-.102-.005a.992.992 0 0 1-.53-.223L.141 32.14 0 32l2.298-2.299a.994.994 0 0 1-.223-.528l-.005-.103v-12.9h-2v-.2h2V3.07c0-.24.085-.461.226-.633L0 .14.14 0l2.297 2.296a.998.998 0 0 1 .633-.226h12.9v-2h.2v2h12.9c.24 0 .46.085.633.226L32 0l.14.14ZM2.582 29.7c.136.105.304.17.49.17h3.4a1 1 0 0 1-.396-.697l-.005-.103v-1h-1a.995.995 0 0 1-.633-.227L2.58 29.699Zm20.704-1.63a13.91 13.91 0 0 1-4.848 1.8h6.633a.8.8 0 0 0 .8-.8v-1h-2.585Zm4.416-.228a.992.992 0 0 1-.528.223l-.103.005h-1v1a1 1 0 0 1-.398.8h3.398a.792.792 0 0 0 .489-.17l-1.86-1.859ZM6.271 29.07a.8.8 0 0 0 .8.8h6.633a13.91 13.91 0 0 1-4.848-1.8H6.271v1Zm2.982-1a13.732 13.732 0 0 0 6.718 1.798V28.07H9.253Zm6.917 1.798a13.732 13.732 0 0 0 6.719-1.798h-6.72v1.798Zm-13.9-.798c0 .185.066.353.17.489l1.856-1.857a.996.996 0 0 1-.22-.53l-.006-.102v-1h-1a.998.998 0 0 1-.8-.4v3.4Zm27.6-3.4a.999.999 0 0 1-.8.4h-1v1l-.005.103c-.02.2-.102.38-.223.528l1.857 1.858a.792.792 0 0 0 .171-.489v-3.4ZM4.58 27.7a.8.8 0 0 0 .49.17h1v-1.66L4.58 27.7Zm1.982-1.63c.714.68 1.5 1.285 2.348 1.8h7.06v-1.8H6.563Zm19.305 0a14.06 14.06 0 0 1-2.259 1.8h2.262v-1.8h-.003Zm.203 1.8h1a.792.792 0 0 0 .489-.17l-1.489-1.49v1.66Zm-9.9 0h7.061a13.853 13.853 0 0 0 2.35-1.8H16.17v1.8Zm-9.9 0h2.262a14.059 14.059 0 0 1-2.259-1.8h-.002v1.8Zm21.43-.311a.792.792 0 0 0 .17-.489v-1h-1.66l1.49 1.489ZM4.27 27.07c0 .184.066.352.17.488l1.488-1.488H4.27v1Zm-2-2a.8.8 0 0 0 .8.8h1v-2.587a13.908 13.908 0 0 1-1.8-4.848v6.635Zm2 .8h1.8v-.004a14.06 14.06 0 0 1-1.8-2.26v2.264Zm2.14 0h9.56v-9.56l-9.56 9.56Zm9.76 0h9.56l-9.56-9.56v9.56Zm11.7-2.263a14.055 14.055 0 0 1-1.8 2.26v.003h1.8v-2.263Zm2-5.17a13.91 13.91 0 0 1-1.8 4.848v2.585h1a.8.8 0 0 0 .8-.8v-6.633Zm-4 7.293v-9.56h-9.56l9.56 9.56Zm-19.6-.003 9.56-9.557H6.27v9.557Zm-2-2.497c.516.847 1.12 1.635 1.8 2.35v-9.41h-1.8v7.06Zm21.8 2.35a13.854 13.854 0 0 0 1.8-2.35v-7.06h-1.8v9.41Zm2-2.691a13.733 13.733 0 0 0 1.8-6.72h-1.8v6.72Zm-25.799-6.72c.018 2.443.67 4.734 1.8 6.718V16.17h-1.8Zm1.8-6.915a13.733 13.733 0 0 0-1.8 6.717h1.8V9.254Zm2-2.693a13.855 13.855 0 0 0-1.8 2.35v7.06h1.8V6.56Zm.2 9.41h9.56L6.27 6.41v9.56Zm10.04 0h9.56V6.409l-9.56 9.562Zm9.76 0h1.8V8.91a13.853 13.853 0 0 0-1.8-2.35v9.41Zm2 0h1.798a13.732 13.732 0 0 0-1.799-6.719v6.719Zm-12.1-.14V6.27H6.41l9.56 9.56Zm.199 0 9.557-9.56H16.17v9.56ZM3.07 6.27a.8.8 0 0 0-.8.8v6.634a13.91 13.91 0 0 1 1.8-4.848V6.271h-1Zm25 2.584a13.907 13.907 0 0 1 1.8 4.85V7.07a.8.8 0 0 0-.8-.8h-1v2.585Zm-23.8-.322a14.063 14.063 0 0 1 1.8-2.26V6.27h-1.8v2.262Zm21.8-2.26a14.059 14.059 0 0 1 1.8 2.26V6.27h-1.8v.002Zm1.773-1.836a.995.995 0 0 1 .227.633v1h1a1 1 0 0 1 .8.4v-3.4a.793.793 0 0 0-.17-.489l-1.857 1.856ZM2.44 2.58a.795.795 0 0 0-.17.49v3.4a1 1 0 0 1 .698-.395l.102-.005h1v-1c0-.24.085-.461.226-.633L2.44 2.58Zm2 2a.795.795 0 0 0-.17.49v1h1.66L4.44 4.58Zm4.472-.31a13.854 13.854 0 0 0-2.35 1.8h9.409v-1.8H8.912Zm14.694 0a14.06 14.06 0 0 1 2.26 1.8h.004v-1.8h-2.264Zm2.603 1.8h1.661v-1a.793.793 0 0 0-.17-.49l-1.491 1.49Zm-10.04 0h9.411a13.854 13.854 0 0 0-2.35-1.8h-7.06v1.8Zm-9.898 0h.003a14.062 14.062 0 0 1 2.26-1.8H6.271v1.8Zm-1.2-1.8a.795.795 0 0 0-.49.17l1.49 1.489V4.27h-1Zm21 1.657 1.487-1.488a.794.794 0 0 0-.488-.17h-1v1.658Zm-23-3.657a.795.795 0 0 0-.49.17l1.856 1.855a.998.998 0 0 1 .633-.226h1v-1c0-.327.16-.617.403-.8H3.07Zm22.599 0c.243.182.4.472.4.8v1h1l.103.004c.2.02.382.1.53.22l1.856-1.855a.795.795 0 0 0-.489-.17h-3.4Zm-9.7 0a13.73 13.73 0 0 0-6.715 1.8h6.716v-1.8Zm2.466 0c1.747.297 3.385.918 4.848 1.8h2.586v-1a.8.8 0 0 0-.8-.8h-6.634Zm-2.266 1.8h6.717a13.733 13.733 0 0 0-6.717-1.8v1.8Zm-9.1-1.8a.8.8 0 0 0-.8.8v1h2.587a13.91 13.91 0 0 1 4.85-1.8H7.07Z"
    />
    <mask
      id="ms-dynamics-a"
      width="18"
      height="25"
      x="7"
      y="4"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
    >
      <path
        fill="#fff"
        d="M24.831 11.774a2.537 2.537 0 0 0-1.684-2.39L8.43 4.13a1.018 1.018 0 0 0-1.358.958v7.99c0 .43.268.814.673.958l6.595 2.357a1.018 1.018 0 0 0 1.358-.958v-4.594c0-.354.355-.598.685-.474l1.73.652a2.532 2.532 0 0 1 1.643 2.373v1.998l-7.45 2.724c-.4.145-.665.528-.665.953v7.987c0 .706.702 1.197 1.362.954l10.162-3.715a2.54 2.54 0 0 0 1.667-2.382V11.774Z"
      />
    </mask>
    <g mask="url(#ms-dynamics-a)">
      <path
        fill="url(#ms-dynamics-b)"
        d="m7.07 3.643 17.757 6.34v8.709c0 .701-.693 1.193-1.354.957l-3.718-1.329v-4.928a2.537 2.537 0 0 0-1.643-2.373l-1.73-.648a.507.507 0 0 0-.685.475v6.03l-8.626-3.08V3.644Z"
      />
      <path
        fill="#000"
        fillOpacity=".24"
        d="M24.827 11.865a2.54 2.54 0 0 1-1.667 2.386l-11.524 4.21v10.145l13.191-4.82v-11.92Z"
      />
      <path
        fill="#000"
        fillOpacity=".32"
        d="M24.827 12.27a2.54 2.54 0 0 1-1.667 2.385l-11.524 4.21v10.146l13.191-4.821V12.27Z"
      />
      <path
        fill="url(#ms-dynamics-c)"
        d="M24.827 11.762a2.54 2.54 0 0 1-1.667 2.386l-11.524 4.21v10.145l13.191-4.821v-11.92Z"
      />
      <path
        fill="url(#ms-dynamics-d)"
        d="M24.827 11.762a2.54 2.54 0 0 1-1.667 2.386l-11.524 4.21v10.145l13.191-4.821v-11.92Z"
        opacity=".5"
      />
      <path
        fill="#B0ADFF"
        d="m19.754 15.394-4.061 1.486v5.952c0 .355.355.598.685.474l1.734-.652a2.531 2.531 0 0 0 1.642-2.373v-4.887Z"
        opacity=".5"
      />
    </g>
    <defs>
      <linearGradient
        id="ms-dynamics-b"
        x1="12.913"
        x2="17.635"
        y1="3.937"
        y2="16.297"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0B53CE" />
        <stop offset="1" stopColor="#7252AA" />
      </linearGradient>
      <linearGradient
        id="ms-dynamics-c"
        x1="18.234"
        x2="18.234"
        y1="27.614"
        y2="12.882"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2266E3" />
        <stop offset="1" stopColor="#AE7FE2" />
      </linearGradient>
      <linearGradient
        id="ms-dynamics-d"
        x1="24.829"
        x2="19.775"
        y1="20.133"
        y2="20.133"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#94B9FF" />
        <stop offset=".288" stopColor="#94B9FF" stopOpacity=".524" />
        <stop offset="1" stopColor="#538FFF" stopOpacity="0" />
      </linearGradient>
    </defs>
  </BaseIcon>
);
